import { useTranslation } from 'react-i18next';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import {
  TiktokBusinessWarningStatus,
  useTiktokBusinessAccountInfoQuery,
  useTiktokBusinessAdAccountsQuery
} from '@anytag/graphql';
import { TikTokAdAccount, useTikTokAdvertiserSummaryData } from '@anytag/shared-organisms';
import { ButtonLink } from '@anytag/shared-atoms';
import { animatedArrows } from '@anytag/shared-assets';

export const TikTokBusinessAccountCenter = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.TikTok Ad Account',
    appHeader: 'appHeader.TikTok Ad Account',
    href: '/tiktok-onboarding/select-plan',
    alwaysBackToParent: true
  });
  const { t } = useTranslation();
  const { data } = useTiktokBusinessAccountInfoQuery();
  const { data: adData } = useTiktokBusinessAdAccountsQuery();
  const { summaryData } = useTikTokAdvertiserSummaryData();

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <TikTokAdAccount
        isOnboardingFlow
        tiktokBusinessAdAccounts={adData?.tiktokBusinessAdAccounts}
        tiktokBusinessAccountInfo={data?.tiktokBusinessAccountInfo}
        hasAccountsLimitWarning={summaryData?.warningsList.includes(
          TiktokBusinessWarningStatus.REACH_ADS_ACCOUNTS_LIMIT
        )}
      />
      {adData?.tiktokBusinessAdAccounts?.length ? (
        <ButtonLink
          variant="solid"
          color="danger"
          title={t("Button.Let's start")}
          to="/tiktok/ad-campaign-report"
          className="ml-auto w-max flex-row-reverse pt-0 pr-4 pb-0 pl-6"
        >
          <img src={animatedArrows} className="h-8 w-8 rotate-270" alt="3 animated arrows pointing to the right" />
        </ButtonLink>
      ) : null}
    </div>
  );
};
